import api from './client'
import { invalidateCache } from '../../utils/cache'

export const getParametres = (forceRefresh = false, requestConfig = {}) => {
  return api.get('/parametres', { useCache: !forceRefresh, ...requestConfig }).then((res) => res.data)
}

export const updateParametres = async (data) => {
  const oldParams = await getParametres().catch(() => ({ devise: 'EUR' }))
  const deviseChanged = oldParams.devise !== data.devise
  const response = await api.put('/parametres', data)
  invalidateCache('/parametres')
  if (deviseChanged) {
    invalidateCache('/stats')
    invalidateCache('/operations')
    invalidateCache('/graphiques')
    invalidateCache('/parametres')
    setTimeout(() => window.dispatchEvent(new Event('currencyChanged')), 100)
  } else {
    invalidateCache('/stats')
  }
  return response.data
}

/**
 * Réinitialise toutes les données opérationnelles (opérations supprimées, comptes à 0, date de création des comptes mise à jour).
 */
export const purgeUserData = () => {
  invalidateCache('/parametres')
  invalidateCache('/stats')
  invalidateCache('/operations')
  invalidateCache('/comptes')
  invalidateCache('/graphiques')
  return api.post('/parametres/purge-data').then((res) => res.data)
}
